import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import ActiveRecord from 'model/activeRecord'
import Medication from 'model/mailOrder/medication'

// TODO: make sure mailorder_status / status is used; remove otherwise
class MailOrderTransferType extends ActiveRecord {
  constructor(init) {
    super(init)
    // console.log('> MailOrderTransferType constructor -', init)
    if (isNil(init)) return undefined
    this._medications = init.medications
      ? init.medications.map(item => new Medication(item))
      : []
    this._status = init.mailorder_status
    this._successful_transfer_notification_sent_at =
      init.successful_transfer_notification_sent_at
  }

  static shape = {
    medications: PropTypes.arrayOf()
  }

  get medications() {
    return this._medications
  }

  get status() {
    return this._status
  }

  get successful_transfer_notification_sent_at() {
    return this._successful_transfer_notification_sent_at
  }
}

export default MailOrderTransferType
